import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// css
import styles from "./Authcss.module.scss";

// images
import logo from "../../Assets/images/logo.png";
import authAfter from "../../Assets/images/authAfter.png";
import authImg from "../../Assets/images/AuthImg.png";
import { PRIVATE_ROUTES } from "../../pages";

const AuthLayout = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate(PRIVATE_ROUTES.DASHBOARD);
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <>
      <section
        className={`${styles.authLayout} authLayout position-relative py-md-5 py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{ zIndex: "99" }}
      >
        <img
          src={authAfter}
          alt=""
          className={`${styles.afterImg} img-fluid afterImg h-100 position-absolute`}
        />
        <Container className="">
          <Row className="justify-content-between align-items-center">
            <Col lg="5" className="my-2 imgWrpper text-center d-lg-block d-none">
              <div className={`${styles.imgWrppInner} imgWrppInner position-relative`}>
                <img src={authImg} alt="authImg" className="img-fluid h-100 w-100" />
              </div>
            </Col>
            <Col lg="5" className={`${styles.formWrpper} formWrpper position-relative my-2`}>
              <div className={`${styles.inner} bg-white inner p-lg-0 px-sm-5 py-3 px-3`}>
                <div className="logo text-center">
                  <img src={logo} alt="" className="img-fluid" />
                </div>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AuthLayout;
